import React from 'react';
import OrderDetailsBody from './order-details-body';
import OrderDetailsHeader from './order-details-header';
import './styles.scss';
import { OrderType } from 'models/order.model';
import styles from '../index.module.css';

type Props = {
  order: OrderType;
};

export const OrderDetailsInfo = ({ order }: Props) => {
  return (
    <div className={`${styles['section']} text-gray-5 overflow-y-auto h-full`}>
      <OrderDetailsHeader order={order} />
      <OrderDetailsBody order={order} />
    </div>
  );
};

export default OrderDetailsInfo;
